module.exports = __webpack_public_path__ + "img/11.5c8c49d2.png";